import { Autocomplete, Button, Grid, IconButton, InputAdornment, TextField, Tooltip, createFilterOptions } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import AutoCompleteSelect from '../AutoComplete/AutoCompleteSelect';
import { MATRICS } from '../../constants';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { MatricsType } from '../../enums';

interface MatricOptionType {
  id?: number;
  name: string | MatricsType;
  label?: string;
}
const filter = createFilterOptions<MatricOptionType>();
const Matric = ({ keyPair, setKeyPair, onKeyPairRemove, onKeyPairAdd, index, items }) => {
  const [keyValue, setKeyValue] = useState(keyPair);
  const [debouncedKeyValue, setDebouncedKeyValue] = useState(keyValue);
  const [selectedMatric, setSelectedMatric] = useState('');
  const [value, setValue] = useState(keyPair.valueItem);
  const [matrics, setMatrics] = useState<MatricOptionType[]>([]);

  const [selectValue, setSelectValue] = React.useState<MatricOptionType | null>(null);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedKeyValue(keyValue);
    }, 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, [keyValue]);

  useEffect(() => {
    setKeyPair(debouncedKeyValue);
    // eslint-disable-next-line
  }, [debouncedKeyValue]);

  const handleOnChange = (e) => {
    const value = Number(e.target.value);
    if (value < 0 || value > 1) {
      setKeyValue((prevState) => ({
        ...prevState,
        id: keyValue.id,
        [e.target.name]: 1,
      }));
      setValue(1);
    } else {
      setKeyValue((prevState) => ({
        ...prevState,
        id: keyValue.id,
        [e.target.name]: e.target.value,
      }));
      setValue(e.target.value);
    }
  };

  const onKeyChange = (value) => {
    // console.log(value);

    setKeyValue((prevState) => ({
      ...prevState,
      id: keyValue.id,
      keyItem: value ? value.name : '',
    }));
    // setSelectedMatric(value);
  };

  useEffect (() => {
    const newItems = MATRICS;
    const newItem = {
      id:keyPair.id,
      label:keyPair.keyItem,
      name:keyPair.keyItem
    };
    setMatrics(newItems);
      const foundMatric = MATRICS.find((m) => m.name === newItem.name);
      if (!foundMatric) {
        newItems.push(newItem)
      }
      setSelectValue(newItem);
      setMatrics(newItems);
  }, [items])

  useEffect(() => {}, [keyPair]);

  return (
    <Grid container spacing={1} direction="row" sx={{ pt: '4px' }}>
      <Grid item xs={3}>
        <Autocomplete
          fullWidth
          value={selectValue}
          onChange={(event, newValue) => {
            // console.log('newValue', newValue);
            if (typeof newValue === 'string') {
              setSelectValue({
                name: newValue,
              });
            } else if (newValue && newValue.name) {
              // Create a new value from the user input
              setSelectValue({
                name: newValue.name,
              });
            } else {
              setSelectValue(newValue);
            }
            onKeyChange(newValue);
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            const { inputValue } = params;
            // Suggest the creation of a new value
            const isExisting = options.some((option) => inputValue === option.name);
            if (inputValue !== '' && !isExisting) {
             
              filtered.push({
                label:`Add "${inputValue}"`,
                name: inputValue,
              });
            }

            return filtered;
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          id="key-options-select"
          options={matrics}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.name) {
              return option.name;
            }
            // Regular option
            return option.name;
          }}
          renderOption={(props, option) => <li {...props}>{option.label}</li>}
          freeSolo
          renderInput={(params) => <TextField {...params} label="Matric" size='small' fullWidth/>}
        />
      </Grid>
      <Grid item xs={9} sx={{display:'flex',}}>
        <TextField
          id="name"
          label="Value"
          variant="outlined"
          placeholder=""
          size="small"
          fullWidth
          name="valueItem"
          value={value}
          onChange={(e) => handleOnChange(e)}
          type="number"
          InputProps={{
            inputProps: { min: 0, max: 1 },
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Used for classification tasks">
                  <InfoRoundedIcon style={{ cursor: 'help' }} fontSize="small" />
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
        {index + 1 === items.length && (
          <IconButton
            sx={{  textAlign: 'left', marginTop:'-5px' }}
            color="primary"
            aria-label="add"
            size="large"
            onClick={() => onKeyPairAdd()}
          >
            <AddIcon />
          </IconButton>
        )}
        {index + 1 !== items.length && (
          <IconButton
            sx={{marginTop:'-5px' }}
            color="error"
            aria-label="delete"
            size="large"
            onClick={() => onKeyPairRemove(keyPair)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Grid>
     
    </Grid>
  );
};

export default Matric;
